import React from 'react'

import Base from './Base'

import { responseTypes, assetsBase } from '../constants'
import { getStudentHeaderCopy } from '../helpers'

export const Correct = ({ questionPoints, title, isTeacher, answersCount }) => {
    return (
        <Base
            type={responseTypes.CORRECT}
            iconPath={`${assetsBase}/correct.svg`}
            title={
                title ||
                getStudentHeaderCopy({ type: responseTypes.CORRECT }) ||
                'Correct answer'
            }
            questionPoints={questionPoints}
            isTeacher={isTeacher}
            answersCount={answersCount}
        />
    )
}

export const Incorrect = ({
    questionPoints,
    title,
    isTeacher,
    answersCount,
}) => {
    return (
        <Base
            type={responseTypes.INCORRECT}
            iconPath={`${assetsBase}/incorrect.svg`}
            title={
                title ||
                getStudentHeaderCopy({ type: responseTypes.INCORRECT }) ||
                'Wrong answer'
            }
            questionPoints={questionPoints}
            isTeacher={isTeacher}
            answersCount={answersCount}
        />
    )
}

export const Timedout = ({
    questionPoints,
    title,
    isTeacher,
    answersCount,
}) => {
    return (
        <Base
            type={responseTypes.TIMEDOUT}
            iconPath={`${assetsBase}/timedout.svg`}
            title={
                title ||
                getStudentHeaderCopy({ type: responseTypes.TIMEDOUT }) ||
                'Timed out'
            }
            questionPoints={questionPoints}
            isTeacher={isTeacher}
            answersCount={answersCount}
        />
    )
}
